import useSWR from "swr";

import { useApi } from "@touchtech/web-api-client";

import { createTenantUrl } from "../services/api";
import { Tenant } from "../types";

export const useTenant = (tenantId: string) => {
  const api = useApi();
  const url = createTenantUrl(tenantId);

  const { data, error, isLoading } = useSWR(!!tenantId && url, api.get);

  return {
    tenant: data as Tenant,
    isLoading,
    error,
  };
};
